<div class="cb-form-error">
    <p>{{message()}}</p>
</div>